// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"971f465e","182":"65e4a3a5","323":"52811028","446":"deefc150","449":"810a8fc4","786":"bfcb4b09","832":"5ee430e0","836":"47e0544c","928":"3fbc4505"}[chunkId] + ".chunk.css";
};